// extracted by mini-css-extract-plugin
export var hidden = "_73-1";
export var visible = "_73-0";